import CodeTag from './CodeTag';
import ImageTag from './ImageTag';
import HorizontalRuleTag from './HorizontalRuleTag';
import SizeTag from './SizeTag';
import CenterTag from './CenterTag';
import RightTag from './RightTag';
import ColorTag from './ColorTag';
import ListTag from './ListTag';
import ListItemTag from './ListItemTag';
import QuoteTag from './QuoteTag';
import LinkTag from './LinkTag';
import createSimpleTag from './createSimpleTag';

const defaultTags = {
  b: createSimpleTag('strong'),
  i: createSimpleTag('em'),
  u: createSimpleTag('u'),
  s: createSimpleTag('strike'),
  h1: createSimpleTag('h1', { STRIP_OUTER: true }),
  h2: createSimpleTag('h2', { STRIP_OUTER: true }),
  h3: createSimpleTag('h3', { STRIP_OUTER: true }),
  h4: createSimpleTag('h4', { STRIP_OUTER: true }),
  h5: createSimpleTag('h5', { STRIP_OUTER: true }),
  h6: createSimpleTag('h6', { STRIP_OUTER: true }),
  pre: createSimpleTag('pre'),
  table: createSimpleTag('table', { DISCARD_TEXT: true }),
  thead: createSimpleTag('thead', { DISCARD_TEXT: true }),
  tbody: createSimpleTag('tbody', { DISCARD_TEXT: true }),
  tr: createSimpleTag('tr', { DISCARD_TEXT: true }),
  th: createSimpleTag('th'),
  td: createSimpleTag('td'),
  code: CodeTag,
  img: ImageTag,
  hr: HorizontalRuleTag,
  size: SizeTag,
  center: CenterTag,
  right: RightTag,
  color: ColorTag,
  list: ListTag,
  '*': ListItemTag,
  quote: QuoteTag,
  url: LinkTag,
  link: LinkTag,
  email: LinkTag,
};
export default defaultTags;
